'use strict';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); 

class BlockPreviewMenu {

	constructor($target) {

		//Private properties
        $target;
        
        function init(){
		    animatePreviewMenuOnEnter();
			
        }

        function animatePreviewMenuOnEnter(){
        
		}
		
        
        init();

		return {

			//Public properties

			publicBlockPreviewMenu:function(string){

			

			}

		}

	}

}

export default BlockPreviewMenu;